import { render, staticRenderFns } from "./ProductsSlider.vue?vue&type=template&id=3f5779be&"
import script from "./ProductsSlider.vue?vue&type=script&lang=js&"
export * from "./ProductsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports